import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const SUPPORT_EMAIL = 'team@farmersmarketspace.com';
const DEMO_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=Request%20a%20Demo%20-%20Farmers%20Marketspace%20Platform`;

export { SUPPORT_EMAIL, DEMO_MAILTO };

const LandingLayout = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="landing-page">
      {/* Main header / nav */}
      <header className="landing-header">
        <div className="landing-header-inner">
          <Link to="/" className="landing-logo">
            <img src="/images/logo.png" alt="" className="landing-logo-img" />
            Farmers <span className="landing-logo-accent">Marketspace</span>
          </Link>
          <nav className="landing-nav">
            <Link to="/">Home</Link>
            <Link to="/solutions">Solutions</Link>
            <a href={DEMO_MAILTO} className="landing-cta-nav landing-cta-desktop">Request a Demo</a>
            <button
              className="landing-mobile-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <i className={`fas fa-${mobileMenuOpen ? 'times' : 'bars'}`}></i>
            </button>
          </nav>
        </div>
        {mobileMenuOpen && (
          <div className="landing-mobile-menu">
            <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
            <Link to="/solutions" onClick={() => setMobileMenuOpen(false)}>Solutions</Link>
            <a href={DEMO_MAILTO} className="landing-mobile-demo">Request a Demo</a>
          </div>
        )}
      </header>

      {children}

      {/* Footer with Contact info */}
      <footer className="landing-footer">
        <div className="landing-container">
          <div className="landing-footer-content">
            <div className="landing-footer-brand">
              <strong>Farmers Marketspace</strong>
              <p>Software for farms, food hubs, and markets.</p>
            </div>
            <div className="landing-footer-contact-section">
              <h4>Contact Us</h4>
              <p><i className="fas fa-envelope"></i> <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></p>
            </div>
            <div className="landing-footer-links">
              <Link to="/">Home</Link>
              <Link to="/solutions">Solutions</Link>
            </div>
          </div>
          <div className="landing-footer-bottom">
            <p>© {new Date().getFullYear()} Farmers Marketspace. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingLayout;
